import { render, staticRenderFns } from "./ModalOrderPart.vue?vue&type=template&id=cbe6985c&"
import script from "./ModalOrderPart.vue?vue&type=script&lang=js&"
export * from "./ModalOrderPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports